import { keepPreviousData } from "@tanstack/react-query";
import {
  retrieveCaseAssignments,
  type CaseAssignmentsFilters,
} from "@/lib/data/requests/reports/reports-case-assignments";
import { queryKeys } from "@/lib/data/static";
export const caseAssignmentsQueryOptions = (
  filters: CaseAssignmentsFilters,
) => ({
  queryKey: [queryKeys.reports, "case-assignments", filters],
  queryFn: ({ signal }: { signal: AbortSignal }) =>
    retrieveCaseAssignments(filters, signal),
  placeholderData: keepPreviousData,
  refetchInterval: 30_000,
});
